import axios from 'axios';
import { User } from '@practium/shared';
import { getApiUrl } from '@practium/features/api';
import { authStorage } from '../storage/authStorage';
import { authLog } from '../logging/auth.logger';

export const authService = {
	getCurrentUser: (): User | null => {
		return authStorage.getUser();
	},

	getToken: (): string | null => {
		return authStorage.getToken();
	},

	isAuthenticated: (): boolean => {
		return authStorage.hasValidSession();
	},

	logout: async (): Promise<void> => {
		const user = authStorage.getUser();
		const token = authStorage.getToken();

		if (token) {
			await axios
				.post(`${getApiUrl()}logout`, null, {
					headers: { Authorization: `bearer ${token}` },
					withCredentials: true,
				})
				.catch(() => undefined);
		}

		if (user) {
			authLog.logLogout(user._id);
		}
		authStorage.clearSession();
	},
};
